import { helper } from '@ember/component/helper';

/*eslint no-unused-vars: 0*/
export default helper(([tag, ...rest]) => `${tag.name} (${tag.count || 0})`);
